import { BotcoAPI } from '@botco/api';
import { constants } from '~/config';

import * as actionTypes from '../types/conversationNew';

const newApiCall = new BotcoAPI(constants.api_url);

export const getIntentsByAgentId = (agent_id) => {
  if (!agent_id) return { type: actionTypes.ALL_INTENTS, payload: [] };
  return async (dispatch) => {
    try {
      const { data } = await newApiCall.getIntents(agent_id);
      return dispatch({ type: actionTypes.ALL_INTENTS, payload: data });
    } catch (error) {
      return dispatch({ type: actionTypes.ALL_INTENTS, payload: [] });
    }
  };
};

export const setSelectedAgent = (agent) => {
  return {
    type: actionTypes.SET_SELECTED_AGENT,
    payload: agent,
  };
};
